export default __webpack_public_path__ + "static/media/Right.baeeb4a0.svg";